import CRMICreateFolderModal from "./CRMICreateFolderModal";

export default CRMICreateFolderModal;
